import { Alert } from '@/components/alert';
import { FormattedMessage } from '@/components/formatted_message/FormattedMessage';
import type { FC } from 'react';
import { MissingCode as messages } from '../messages';
import { ButtonAnt } from '@/components/buttons/button/ButtonAnt';
import { useHistory } from 'react-router-dom';
import { AuthContentLayout } from '@/routes/auth/components/AuthContentLayout';

export const SuccessAdminNotifiedContent: FC = () => {
  const history = useHistory();

  return (
    <AuthContentLayout
      alert={<Alert showIcon type="info" description={<FormattedMessage {...messages.alertInfoMessage} />} />}
      actions={
        <ButtonAnt block onClick={() => history.push('/')} size="large" type="primary">
          <FormattedMessage {...messages.close} />
        </ButtonAnt>
      }
    />
  );
};
